"use strict";
// ==========================================
// Game Field
// ==========================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_DURATION = exports.RESULTS_DURATION = exports.MAX_DURATION = exports.TICK_INTERVAL_MS = exports.INPUT_BUFFER_SIZE = exports.BROADCAST_RATE = exports.TICK_RATE = exports.MAX_PLAYERS_ON_SERVER = exports.MIN_PLAYERS_ON_SERVER = exports.RECONNECT_INVULNERABILITY = exports.MAX_DISCONNECTS_PER_SESSION = exports.DISCONNECT_COOLDOWN = exports.GRACE_PERIOD = exports.SPAWN_MIN_DISTANCE = exports.INVULNERABILITY_TIME = exports.RESPAWN_TIME_LIMIT = exports.MAX_RESPAWNS = exports.RESPAWN_PHASE_MULTIPLIER_END = exports.RESPAWN_PHASE_MULTIPLIER_START = exports.RESPAWN_BASE_PERCENT = exports.PORTAL_RELOCATE_WARNING = exports.PORTAL_RELOCATE_INTERVAL = exports.PORTAL_MIN_SAFE_DISTANCE = exports.PORTAL_RADIUS = exports.SPARKS_PER_STAR = exports.SPARK_SIZE = exports.SPARK_VALUE = exports.FOLLOW_LERP = exports.MAX_ZOOM = exports.MIN_ZOOM = exports.ZOOM_FACTOR = exports.BASE_ZOOM = exports.DEATH_SPARK_SCATTER_RADIUS = exports.BASE_TURN_RATE = exports.MIN_BOOST_LENGTH = exports.HEAD_COLLISION_THRESHOLD = exports.SEGMENT_SPACING = exports.SEGMENT_COLLISION_RADIUS = exports.COLLISION_RADIUS = exports.MIN_LENGTH = exports.BOOST_SPARK_DROP_RATE = exports.BOOST_COST = exports.SPARKS_PER_STAR_GROWTH = exports.TURN_RATE = exports.BOOST_MULTIPLIER = exports.BASE_SPEED = exports.INITIAL_WIDTH = exports.INITIAL_LENGTH = exports.BOUNDARY_KILL_MARGIN = exports.FIELD_RADIUS = void 0;
exports.SPAWN_SCATTER_RADIUS = exports.FREE_TRIAL_GAMES = exports.DEATH_DROP_PERCENT = exports.MAX_STAKE = exports.MIN_STAKE = exports.FREE_SPARKS_BONUS = exports.FINAL_COUNTDOWN_TIME = exports.RED_PULSE_TIME = exports.WARNING_BANNER_TIME = exports.COLLAPSE_DURATION = void 0;
exports.FIELD_RADIUS = 50000;
// Static boundary: touching the edge = instant death (slither.io style).
// No shrinking red zone — the boundary is fixed for the entire session.
exports.BOUNDARY_KILL_MARGIN = 200; // units outside boundary before death
// ==========================================
// Snake
// ==========================================
exports.INITIAL_LENGTH = 1;
exports.INITIAL_WIDTH = 120; // world units; at zoom=0.12 renders as ~14px head radius
exports.BASE_SPEED = 1000;
exports.BOOST_MULTIPLIER = 2.5;
exports.TURN_RATE = 20;
exports.SPARKS_PER_STAR_GROWTH = 100;
exports.BOOST_COST = 2;
exports.BOOST_SPARK_DROP_RATE = 2;
exports.MIN_LENGTH = 5;
exports.COLLISION_RADIUS = 120; // ~= INITIAL_WIDTH for head-on detection
exports.SEGMENT_COLLISION_RADIUS = 80; // head-to-body collision radius
exports.SEGMENT_SPACING = 60; // < INITIAL_WIDTH/2 so segments visually overlap (snake body)
exports.HEAD_COLLISION_THRESHOLD = 0.2;
exports.MIN_BOOST_LENGTH = 10;
exports.BASE_TURN_RATE = 4.2;
exports.DEATH_SPARK_SCATTER_RADIUS = 800; // radius to scatter death sparks
// ==========================================
// Camera
// ==========================================
// At FIELD_RADIUS=50000 and BASE_SPEED=800, a 1280px screen at zoom=0.12
// sees ~10667 world units — map diameter (100000) spans ~9.4 screens.
// On mobile (390px) visible width is ~3250 wu — map spans ~30 screens.
// Head (120 wu) renders as ~14px — matches slither.io proportions.
exports.BASE_ZOOM = 0.12;
exports.ZOOM_FACTOR = 0.00002;
exports.MIN_ZOOM = 0.03;
exports.MAX_ZOOM = 0.18;
exports.FOLLOW_LERP = 0.1;
// ==========================================
// Sparks
// ==========================================
exports.SPARK_VALUE = 1;
exports.SPARK_SIZE = 40; // world units; at zoom=0.12 renders as ~4.8px core + glow
exports.SPARKS_PER_STAR = 100;
// ==========================================
// Exit Portal
// ==========================================
exports.PORTAL_RADIUS = 300;
exports.PORTAL_MIN_SAFE_DISTANCE = 500;
exports.PORTAL_RELOCATE_INTERVAL = 60;
exports.PORTAL_RELOCATE_WARNING = 5;
// ==========================================
// Respawn
// ==========================================
exports.RESPAWN_BASE_PERCENT = 0.1;
exports.RESPAWN_PHASE_MULTIPLIER_START = 1.5;
exports.RESPAWN_PHASE_MULTIPLIER_END = 0.5;
exports.MAX_RESPAWNS = 3;
exports.RESPAWN_TIME_LIMIT = 300;
exports.INVULNERABILITY_TIME = 5;
exports.SPAWN_MIN_DISTANCE = 800;
// ==========================================
// Disconnect
// ==========================================
exports.GRACE_PERIOD = 10;
exports.DISCONNECT_COOLDOWN = 60000;
exports.MAX_DISCONNECTS_PER_SESSION = 3;
exports.RECONNECT_INVULNERABILITY = 3;
// ==========================================
// Server
// ==========================================
exports.MIN_PLAYERS_ON_SERVER = 10;
exports.MAX_PLAYERS_ON_SERVER = 50;
exports.TICK_RATE = 30;
exports.BROADCAST_RATE = 20;
exports.INPUT_BUFFER_SIZE = 60;
exports.TICK_INTERVAL_MS = Math.round(1000 / exports.TICK_RATE);
// ==========================================
// Game Time
// ==========================================
exports.MAX_DURATION = 3600;
exports.RESULTS_DURATION = 10;
// ==========================================
// Session Lifecycle
// ==========================================
exports.SESSION_DURATION = 3600;
exports.COLLAPSE_DURATION = 10;
exports.WARNING_BANNER_TIME = 300;
exports.RED_PULSE_TIME = 60;
exports.FINAL_COUNTDOWN_TIME = 10;
// ==========================================
// Economy
// ==========================================
exports.FREE_SPARKS_BONUS = 0;
exports.MIN_STAKE = 1;
exports.MAX_STAKE = 3;
exports.DEATH_DROP_PERCENT = 1.0;
exports.FREE_TRIAL_GAMES = 5;
exports.SPAWN_SCATTER_RADIUS = 200; // scaled for larger map
//# sourceMappingURL=constants.js.map